import { useElplanClearBidsMutation } from 'api/elplan/elplan.api'
import React, { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import NewButton from 'ui/atoms/NewButton/NewButton'
import { getActiveContextSubTextList } from 'ui/components/BidSubmitConfirmDialog/BidSubmitConfirmDialog.helper'
import ConfirmDialog from 'ui/components/ConfirmDialog/ConfirmDialog'
import Datetime from 'utils/datetime/datetime'

let withdrawalSequence = 0

type ClearBidsActionProps = {
  date: ISODateTime
  systemName: string
  systemId: number
  isPreview: boolean
  isSuperUser: boolean
  disabled?: boolean
  clearContextKeys?: string[]
  onClearSuccess?: (contextKeys: string[], withdrawalId: string) => void
}

export function ClearBidsAction({
  date,
  systemName,
  systemId,
  isPreview,
  isSuperUser,
  disabled,
  clearContextKeys = [],
  onClearSuccess,
}: ClearBidsActionProps): ReactNode {
  const { t } = useTranslation()
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const { mutate: clearBids, isPending } = useElplanClearBidsMutation()

  const bidDate = Datetime.toLocalTime(date, 'onlyDate')

  function handleConfirm(): void {
    setIsConfirmOpen(false)
    const withdrawalId = `${systemId}:${bidDate}:${++withdrawalSequence}`
    const contextKeysAtConfirmation = [...clearContextKeys]
    clearBids(
      { date: bidDate, system: systemName, systemId },
      {
        onSuccess: () => onClearSuccess?.(contextKeysAtConfirmation, withdrawalId),
      }
    )
  }

  const activeContext = isSuperUser
    ? [
        t('Please verify the active context:'),
        ...getActiveContextSubTextList({ systemName, isPreview, stage: process.env.REACT_APP_STAGE }, t),
      ]
    : undefined

  return (
    <>
      <NewButton
        variant="outlined"
        label={t('Withdraw sent bids')}
        style={{ marginLeft: '10px' }}
        disabled={disabled || isPending}
        loading={isPending}
        onClick={() => setIsConfirmOpen(true)}
      />
      <ConfirmDialog
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirm}
        initialFocus="deny"
        textObject={{
          title: t('Withdraw sent bids'),
          text: t('Withdraw the bids sent for {{date}}? They will also be deleted.', { date: bidDate }),
          confirm: t('Withdraw'),
          deny: t('Cancel'),
        }}
        subTextList={activeContext}
      />
    </>
  )
}
